import React from 'react';

class SimpleInput extends React.Component {
  render = () => {
    const {
      type,
      value,
      name,
      placeholder,
      autoComplete,
      className = this.props.newStyles ? 'simple-input-new' : 'simple-input',
      disabled = false
    } = this.props;
    const inputProps = {
      type,
      name,
      autoComplete,
      placeholder,
      className,
      disabled,
      onChange: this.handleChange,
      onBlur: this.handleBlur,
      onFocus: this.test
    };
    inputProps.value = 'mask' in this.props ? this.props.mask(value) : value;

    return <input {...inputProps} />;
  };

  test = () => {
    console.log('test on focus');
  };

  handleChange = e => {
    if ('mask' in this.props) {
      e.target.value = this.props.mask(e.target.value);
    }

    if ('onChange' in this.props) this.props.onChange(e);
  };

  handleBlur = e => {
    if ('onBlur' in this.props) this.props.onBlur(e);
  };
}

export default SimpleInput;



// WEBPACK FOOTER //
// ./src/components/form/SimpleInput.js